import React, { useState, useEffect } from "react";
import Sub_header from './Sub_header'

import axios from "axios";


import exportValue from "../apiconfig";
import ReactLoading from 'react-loading';
import Swal from 'sweetalert2'
import Left_panel from "./Left_panel";
import Moment from 'react-moment';
import { el } from "date-fns/locale";

const My_referrals = () => {
    const[state,setState] = React.useState([])
    const[adminstate,setadminState] = React.useState([])

    let admindata = {};
if (localStorage.getItem('admin_login')) {
  admindata = JSON.parse(localStorage.getItem('admin_login'));
  console.log("admindata------>  -  ",admindata);
  
}
     const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    
       const toggleSidebar = () => {
           setIsSidebarOpen(!isSidebarOpen);
           const homeSection = document.querySelector('.home-section');
           if (homeSection) {
               homeSection.classList.toggle('sidebar-closed');
           }
       };

       React.useEffect(()=>{
        getAdminDetail()
    },[])

    React.useEffect(()=>{
        if(adminstate.length>0){
        getReferrals()
        }
    },[adminstate])

    const getAdminDetail=()=>{
        let dataToSend = {admin_id : admindata.admin_id };
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/get_admin_detail`;
       
         axios.post(full_api, dataToSend, { headers: exportValue.headers }).then((res) => {
                if(res.data.status==true){
                    setadminState(res.data.output)
        }
       else{
           const Toast = Swal.mixin({
               toast: true,
               position: 'bottom-end',
               showConfirmButton: false,
               timer: 3000
             })
             Toast.fire({
               background:"#a61c09",
               type: 'Unsuccess',
               title: "Something Went Wrong !",
               color:"white"
             });
       } 
    })  .catch((error) => {
               const Toast = Swal.mixin({
                   toast: true,
                   position: 'bottom-end',
                   showConfirmButton: false,
                   timer: 3000
                 })
                 Toast.fire({
                   background:"#a61c09",
                   type: 'Unsuccess',
                   title: "Something Went Wrong !",
                   color:"white"
                 });
                 // console.log(error);
             });    
       
       }

        const getReferrals=()=>{
            let id =""
            let full_api = ""
            if(adminstate.length>0){
                if(adminstate[0].am_id){
                    id = adminstate[0].am_id
                }
                else if(adminstate[0].ndr_id){
                    id = adminstate[0].ndr_id
                }
            }

            if(admindata.admin_type==10){
                full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/get_my_refferals`;
            }
            else if(admindata.admin_type==11){
                full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/get_my_refferals_for_ndr`;
            }
            let dataToSend = {admin_id : admindata.admin_id, id:id};
            
           
             axios.post(full_api, dataToSend, { headers: exportValue.headers }).then((res) => {
                    if(res.data.status==true){
                    setState(res.data.output)
            }
           else{
              
           } 
        })
               
                 .catch((error) => {
                   const Toast = Swal.mixin({
                       toast: true,
                       position: 'bottom-end',
                       showConfirmButton: false,
                       timer: 3000
                     })
                     Toast.fire({
                       background:"#a61c09",
                       type: 'Unsuccess',
                       title: "Something Went Wrong !",
                       color:"white"
                     });
                     // console.log(error);
                 });    
           
           }
  return (
    <div>
        <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
       
       <section class="home-section">
       <Sub_header/>
       <div class="row justify-content-between">
    <div class="col-12 col-md-4 desk_nav">
      <div class="d-flex">
        {/* <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a> */}
        <h2>My Referrals</h2>
      </div>
    </div>
</div>





<div class="card border-0">
  <div class="card-body">
    <table class="table table-bordered">
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Client Name</th>
            <th>Referral Date</th>
          </tr>
        </thead>
        <tbody>
            {state.map((sub , index)=>(
          <tr>
            <td>{index+1}</td>
            <td>{sub.full_name}</td>
            <td><Moment format="YYYY-MM-DD  hh:mm:ss a">
                         {new Date(sub.created*1000)}
             </Moment></td>
          </tr>
          ))}
         
        </tbody>
      </table>
  </div>
</div>
       </section>
    </div>
  )
}

export default My_referrals
